import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const ShareIcon = (props) => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={53}
      height={52}
      viewBox="0 0 53 52"
      fill="none"
      {...props}
    >
      <path
        d="M39.482 34.98c-1.63 0-3.151.542-4.237 1.624l-15.535-8.98c.109-.541.217-.975.217-1.516 0-.54-.108-.974-.217-1.515l15.318-8.871c1.195 1.082 2.716 1.73 4.454 1.73 3.585 0 6.518-2.921 6.518-6.492 0-3.57-2.933-6.491-6.518-6.491s-6.518 2.921-6.518 6.492c0 .54.108.974.217 1.515l-15.317 8.871c-1.196-1.082-2.716-1.73-4.455-1.73C9.825 19.617 7 22.538 7 26.108S9.933 32.6 13.518 32.6c1.738 0 3.26-.649 4.454-1.73L33.4 39.85c-.11.432-.218.865-.218 1.406 0 3.463 2.824 6.275 6.3 6.275s6.301-2.812 6.301-6.275-2.824-6.275-6.3-6.275"
        fill="#3C82F6"
      />
    </svg>
  </SVGUniqueID>
);
export { ShareIcon };
